<template>
  <section class="das-form-container">
    <div class="das-form-group">
      <div class="das-form-group-title">Chi tiết đặt phòng</div>
      <div class="das-layout gap-20">
        <div class="l-w-50">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="">
                <div class="label required">
                  {{ 'Master' }}
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="is_master"
                    v-model="formData.is_master"
                    :disabled="isEditCheckedIn"
                    type="checkbox"
                  />
                  <label for="is_master">
                    {{ 'Master' }}
                  </label>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="">
                <div class="label required">
                  {{ 'Trong ngày' }}
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="hour_stay"
                    v-model="formData.hour_stay"
                    :disabled="isEditCheckedIn"
                    type="checkbox"
                    @input="onChangeHourStay"
                  />
                  <label for="hour_stay">
                    {{ 'Trong ngày' }}
                  </label>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="">
                <div class="label">
                  {{ $t('field.amountOfNight') }}
                </div>
                <validation-provider
                  :name="$t('field.amountOfNight')"
                  rules="required|number|min_value:0"
                >
                  <input
                    v-model="numberOfNights"
                    v-numeric-only
                    type="number"
                    :disabled="isDisable"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label required">
                  {{ $t('field.checkInDate') }}
                </div>
                <div class="das-layout gap-10">
                  <div class="l-w-66">
                    <CalendarSelect
                      v-model="formData.arrive_date"
                      mode="date"
                      :disabled="isEditCheckedIn"
                      :min-max="{ min: minDate }"
                    />
                  </div>
                  <div class="l-w-33">
                    <TimePicker
                      v-model="formData.arrive_time"
                      :disabled="isEditCheckedIn"
                      hide-clear-button
                      format="HH:mm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label required">
                  {{ $t('field.checkOutDate') }}
                </div>
                <div class="das-layout gap-10">
                  <div class="l-w-66">
                    <CalendarSelect
                      v-model="formData.depart_date"
                      mode="date"
                      :disabled="isEditCheckedIn"
                      :min-max="{
                        min: formData.arrive_date,
                        max: maxDepartDate
                      }"
                    />
                  </div>
                  <div class="l-w-33">
                    <TimePicker
                      v-model="formData.depart_time"
                      :disabled="isEditCheckedIn"
                      hide-clear-button
                      format="HH:mm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <el-row :gutter="8" class="">
                <el-col :span="6">
                  <div class="label das-label das-label--required">
                    {{ $t('field.numOfAdult') }}
                  </div>
                  <validation-provider
                    :name="$t('field.numOfAdult')"
                    rules="required|number|min_value:0"
                  >
                    <input
                      v-model.number="formData.num_of_guest"
                      v-numeric-only
                      type="number"
                    />
                  </validation-provider>
                </el-col>
                <el-col :span="6">
                  <div class="label das-label">
                    {{ $t('field.numOfChildren') }}
                  </div>
                  <input
                    v-model.number="formData.child_num"
                    v-numeric-only
                    type="number"
                  />
                </el-col>
                <el-col :span="6">
                  <div class="label das-label">Trẻ em dưới 5 tuổi</div>
                  <input
                    v-model.number="formData.u5_child_num"
                    v-numeric-only
                    type="number"
                  />
                </el-col>
                <el-col :span="6">
                  <div class="label">Tổng số khách</div>
                  <input disabled :value="totalGuestsNumber" type="number" />
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <el-row :gutter="8">
                <el-col :span="8">
                  <div class="label das-label das-label--required required">
                    {{ 'Tiền tệ' }}
                  </div>
                  <el-select
                    v-model.number="formData.currency_id"
                    :disabled="isEditCheckedIn"
                    :default-first-option="true"
                    @change="onChangeCurrency"
                  >
                    <el-option
                      v-for="option in currencyOptions"
                      :key="option.id"
                      :label="option.code"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <div class="label">
                    {{ 'Tỉ giá' }}
                  </div>
                  <input
                    v-model.number="formData.exchange_rate"
                    :disabled="isEditCheckedIn"
                    type="number"
                    step="0.1"
                  />
                </el-col>
                <el-col :span="8">
                  <div class="label">
                    {{ 'Miễn phí/Nội bộ' }}
                  </div>
                  <el-select
                    v-model="formData.price_type"
                    :disabled="isEditCheckedIn"
                    clearable
                  >
                    <el-option :value="1" label="Miễn phí"></el-option>
                    <el-option :value="2" label="Nội bộ"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="l-w-50">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label">Khách sạn</div>
                <el-select
                  v-model="hotel_id"
                  filterable
                  clearable
                  :disabled="isDisable || isEditCheckedIn"
                  @change="onChangeHotel"
                >
                  <el-option
                    v-for="option in hotelOptions"
                    :key="option.id"
                    :label="option.name"
                    :value="option.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label required das-label das-label--required">
                  {{ $t('field.bookedRoomLevel') }}
                </div>
                <select-with-search-table
                  style="width: 100%"
                  :disabled="isDisable || isEditCheckedIn"
                  :suppress-row-hover-highlight="true"
                  :rows="filteredRoomLevelOptions"
                  :columns="roomLevelOptionsCol"
                  row-class="room-level-row"
                  :get-row-class="getRowClass"
                  :search-fields="['room_type_name', 'room_level_code']"
                  :value="formData.room_type_id"
                  :selected-index-field-value="formData.room_type_id"
                  index-field="room_level_id"
                  @selectionChanged="onChangeRoomLevel"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    {{ selectedData?.room_type_name }}
                  </template>
                </select-with-search-table>
              </div>
            </div>
          </div>
          <div v-if="formData.rowIndex !== null" class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label">
                  {{ $t('field.roomBooking') }}
                </div>
                <div class="input-group">
                  <input
                    :disabled="isEditCheckedIn"
                    :value="selectedRoom?.room_num"
                    type="text"
                    @click="onOpenSelectRoomDialog"
                  />
                  <div class="input-group__append input-group-btn">
                    <button @click="onRemoveRoom">
                      <i class="el-icon-delete"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="das-form-row">
            <div class="das-form-col col-12">
              <div class="label">
                {{ 'Số phòng' }}
              </div>
              <input
                v-model="formData.num_of_room"
                v-numeric-only
                :disabled="isEditCheckedIn"
                type="text"
                placeholder="Số lượng phòng đặt"
              />
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="label das-label">Số thẻ miễn phí</div>
              <input
                v-model.number="formData.num_of_free_card"
                v-numeric-only
                :disabled="isEditCheckedIn"
                type="number"
              />
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label">
                  {{ 'Khác' }}
                </div>
                <div class="das-layout gap-10">
                  <div class="checkbox-wrap l-w-50">
                    <input
                      id="lockChangeRoom"
                      v-model="formData.block_room"
                      :disabled="!canLockTransferRoom"
                      type="checkbox"
                    />
                    <label for="lockChangeRoom">
                      {{ $t('field.lockChangeRoom') }}
                    </label>
                  </div>
                  <div class="l-w-50 flex align-center">
                    <div class="flex align-center" style="gap: 20px">
                      <!-- <div class="checkbox-wrap">
                  <input
                    id="notPrintPrice"
                    v-model="formData.no_price_printing"
                    type="checkbox"
                  />
                  <label for="notPrintPrice">
                    {{ $t('field.notPrintPrice') }}
                  </label>
                </div> -->
                      <div class="checkbox-wrap">
                        <input
                          id="nett"
                          v-model="formData.nett"
                          :disabled="isEditCheckedIn"
                          type="checkbox"
                        />
                        <label for="nett">
                          {{ 'NETT' }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="l-w-50 flex align-center">
                    <div class="flex align-center" style="gap: 20px">
                      <div class="checkbox-wrap">
                        <input
                          id="buffet"
                          v-model="formData.is_bf"
                          type="checkbox"
                          :disabled="isBuffetDisabled || isEditCheckedIn"
                          @change="onChangeBuffet"
                        />
                        <label for="buffet">
                          {{ 'Buffet' }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <!--                   <div class="checkbox-wrap l-w-50">
                    <input
                      id="notAddService"
                      v-model="formData.no_extra_service"
                      type="checkbox"
                    />
                    <label for="notAddService">
                      {{ $t('field.notAddService') }}
                    </label>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="das-form-group">
      <div class="das-form-group-title">Giá ngày</div>
      <BookingRoomDailyPriceTable
        ref="BookingRoomDailyPriceTable"
        :disabled="isEditCheckedIn"
        :record-rows="formData.daily_price"
        @updateRow="onUpdateDailyPriceRow"
      ></BookingRoomDailyPriceTable>
    </div>
    <hr />
    <div class="das-form-group">
      <div class="justify-space-between">
        <label for="" class="mr-10 das-form-group-title">Phụ thu phí</label>
        <!-- :hidden="!canAddRoomService" -->
        <button
          class="btn small primary outline"
          style="margin-bottom: 8px"
          @click="onOpenBookingAddChargeDialog"
        >
          Chỉnh sửa
        </button>
      </div>
      <booking-room-add-charge-table
        :key="formData.room_type_id"
        :record-rows="formData.sub_booking_group_surcharges"
      ></booking-room-add-charge-table>
      <el-dialog
        append-to-body
        :title="$t('field.addCharge')"
        :visible.sync="isAddChargeDialogOpened"
        :close-on-click-modal="false"
        width="80%"
        @closed="isAddChargeDialogOpened = false"
      >
        <booking-room-add-charge-dialog
          :key="formData.room_type_id"
          ref="BookingRoomAddChargeDialog"
          :arrive-date="formData.arrive_date"
          :depart-date="formData.depart_date"
          :room-level-id="formData.room_type_id"
          :booking-room="formData"
        ></booking-room-add-charge-dialog>
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; gap: 10px; justify-content: flex-end"
        >
          <button class="btn primary small" @click="onConfirmAddCharge">
            Cập nhật
          </button>
          <button
            class="btn primary small outline"
            @click="isAddChargeDialogOpened = false"
          >
            Đóng
          </button>
        </span>
      </el-dialog>
    </div>
    <hr />
    <div class="das-form-group">
      <div class="justify-space-between">
        <label for="" class="mr-10 das-form-group-title"
          >Dịch vụ đặc biệt</label
        >
        <button
          :hidden="!canAddRoomService"
          class="btn small primary outline"
          style="margin-bottom: 8px"
          @click="onOpenBookingRoomServiceDialog"
        >
          Chỉnh sửa
        </button>
      </div>
      <BookingRoomServiceTable
        :record-rows="formData.sub_booking_group_services"
      ></BookingRoomServiceTable>
      <el-dialog
        append-to-body
        :title="$t('field.titleSpecialService')"
        :visible.sync="isServiceDialogOpened"
        :close-on-click-modal="false"
        width="80%"
        @closed="isServiceDialogOpened = false"
      >
        <BookingRoomServiceDialog
          ref="BookingRoomServiceDialog"
          :arrive-date="formData.arrive_date"
          :depart-date="formData.depart_date"
          :booking-room="formData"
        ></BookingRoomServiceDialog>
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; gap: 10px; justify-content: flex-end"
        >
          <button class="btn primary small" @click="onConfirmService">
            Cập nhật
          </button>
          <button
            class="btn primary small outline"
            @click="isServiceDialogOpened = false"
          >
            Đóng
          </button>
        </span>
      </el-dialog>
    </div>

    <BookingRoomSelectRoomDialog
      v-if="isSelectRoomDialogOpened"
      :selected-data="{
        roomNumber: null,
        hotelId: hotel_id,
        roomLevelId: formData.room_type_id,
        arriveDate: formData.arrive_date,
        departDate: formData.depart_date,
        depart_time: formData.depart_time,
        arrive_time: formData.arrive_time
      }"
      :hotels="hotelOptions"
      @close="isSelectRoomDialogOpened = false"
      @roomSelected="onRoomSelected"
    ></BookingRoomSelectRoomDialog>
  </section>
</template>
<script>
/* eslint-disable */
import { checkAuthorized } from '@/utils/helper'

import { getBookingGroupAvailableRoomLevelListApi } from '@/api/booking_service/bookingGroupApi'
import { getAllHotels } from '@/api/configuration/hotel/hotel'
import { getAllCurrencyApi } from '@/api/common/currency'
import { getRoomListApi } from '@/api/booking_service/bookingGroup'
import BookingRoomServiceTable from '@/components/resources/booking/BookingRoomServiceTable.vue'
import BookingRoomAddChargeTable from '@/components/resources/booking/BookingRoomAddChargeTable.vue'
import BookingRoomDailyPriceTable from '@/components/resources/booking/BookingRoomDailyPriceTable.vue'
import BookingRoomServiceDialog from '@/components/resources/booking/BookingRoomServiceDialog.vue'
import BookingRoomAddChargeDialog from '@/components/resources/booking/BookingRoomAddChargeDialog.vue'
import BookingRoomSelectRoomDialog from '@/views/mci/group/components/BookingRoomSelectRoomDialog.vue'
import { generateDailyPriceApi } from '@/api/booking_service/booking'
import { newDateFromLocal } from '@/utils/date'
export default {
  components: {
    BookingRoomSelectRoomDialog,
    BookingRoomServiceDialog,
    BookingRoomDailyPriceTable,
    BookingRoomServiceTable,
    BookingRoomAddChargeTable,
    BookingRoomAddChargeDialog
  },
  props: {
    action: {
      default: () => 'create',
      validator(value) {
        return ['create', 'edit', 'view', 'edit-checked-in'].includes(value)
      }
    },
    recordData: null,
    excludedRoomIds: {
      default: () => []
    },
    isDisable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isHydrated: false,
      isServiceDialogOpened: false,
      isAddChargeDialogOpened: false,
      isSelectRoomDialogOpened: false,
      hotel_id: null,
      selectedRoom: null,
      minDate: newDateFromLocal(new Date()),
      formData: {
        id: null,
        hour_stay: false,
        daily_price: [],
        num_of_guest: null,
        num_of_night: 1,
        num_of_room: null,
        room_type_id: null,

        arrive_date: this.$moment(newDateFromLocal(new Date())).format(
          'YYYY-MM-DD'
        ),
        depart_date: this.$moment(newDateFromLocal(new Date()))
          .add(1, 'days')
          .format('YYYY-MM-DD'),
        arrive_time: {
          HH: '14',
          mm: '00'
        },
        depart_time: {
          HH: '12',
          mm: '00'
        },

        child_num: null,
        u5_child_num: null,
        room_id: null,
        price_type: null,
        block_room: false,
        is_master: null,

        room_type_code: null,
        room_num: null,
        nett: true,
        price: null,
        room: null,
        is_bf: false,
        num_of_free_card: 2,

        currency_id: null,
        currency_code: null,
        exchange_rate: null,
        discount_reason: null,
        percent_discount: null,
        amount_discount: null,

        no_price_printing: false,
        no_extra_service: false,
        sub_booking_group_services: [],
        sub_booking_group_surcharges: []
      },
      hotelOptions: [],
      roomTypeOptions: [],
      roomLevelOptions: [],
      roomOptions: [],
      currencyOptions: [],

      roomLevelOptionsCol: [
        {
          headerName: 'Tên',
          field: 'room_type_name',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng',
          field: 'total_room',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng trống',
          field: 'room_available_num',
          // cellClass: "grid-cell-centered",
          flex: 3
        }
      ],
      roomOptionsColumns: []
    }
  },
  computed: {
    isEditCheckedIn() {
      return this.action === 'edit-checked-in'
    },
    isBuffetDisabled() {
      return this.hotel_id !== 45
    },
    canLockTransferRoom() {
      return checkAuthorized('LOCK_TRANSFER_ROOM')
    },
    canAddRoomService() {
      // return checkAuthorized('TRANSACTION_ADD_ROOM_SERVICE_GROUP')
    },
    filteredRoomLevelOptions() {
      if (this.hotel_id == null || this.hotel_id === '') {
        return this.roomLevelOptions
      }
      return this.roomLevelOptions.filter(
        room => room.hotel_id === this.hotel_id
      )
    },
    numberOfNights() {
      const oneDay = 24 * 60 * 60 * 1000

      const numberOfNight = Math.round(
        Math.abs(
          (new Date(this.formData.depart_date) -
            new Date(this.formData.arrive_date)) /
            oneDay
        )
      )
      return numberOfNight === 0 ? 1 : numberOfNight
    },
    maxDepartDate() {
      return this.formData.hour_stay === false
        ? null
        : this.$moment(this.formData.arrive_date).add(1, 'd').toDate()
    },
    totalGuestsNumber() {
      return (
        Number(this.formData.num_of_guest) +
        Number(this.formData.u5_child_num) +
        Number(this.formData.child_num)
      )
    }
  },
  watch: {
    'formData.arrive_date': {
      handler() {
        if (this.formData.depart_date < this.formData.arrive_date) {
          this.formData.depart_date = this.$moment(this.formData.arrive_date)
            .add(1, 'days')
            .format('YYYY-MM-DD')
        }
        this.onChangeBookingDate()
      }
    },
    'formData.depart_date': {
      handler() {
        this.onChangeBookingDate()
      }
    },
    'formData.arrive_time': {
      handler() {
        this.onChangeBookingDate()
      },
      deep: true
    },
    'formData.depart_time': {
      handler() {
        this.onChangeBookingDate()
      },
      deep: true
    }
  },
  async created() {
    this.isHydrated = false
    this.hydrateForm(this.recordData)
    await Promise.all([
      this.getHotelOptions(),
      this.getCurrencyOptions(),
      this.getRoomTypeOptions(
        `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
        `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      )
    ])

    /*
      Add this to update daily price when default
      form values is passed from Room Schedule page
    */
    if (this.totalGuestsNumber === 0 && this.formData.room_type_id) {
      this.getDailyPrice()
    }
    this.isHydrated = true
  },
  mounted() {},
  methods: {
    onChangeBuffet() {
      if (
        this.formData.room_type_id &&
        this.formData.arrive_date &&
        this.formData.depart_date
      ) {
        this.getDailyPrice()
      }
    },
    getRowClass(params) {
      let color = null

      const hotelId = params.data.hotel_id
      switch (hotelId) {
        // Khách sạn đoàn tàu
        case 46:
          color = 'green'
          break
        // Khu cắm trại
        case 45:
          color = 'yellow'
          break
        // Làng cổ tích
        case 44:
          color = 'red'
          break
        // Nebula
        case 47:
          color = 'purple'
          break
        // Nhà sàn thái
        case 48:
        default:
          color = 'brown'
          break
      }
      return 'room-level-row room-level-row--' + color
    },
    onUpdateDailyPriceRow(colName, params, value) {
      const rowIndex = params.rowIndex
      const fieldName = params.colDef.field
      this.formData.daily_price[rowIndex][fieldName] = value
      if (fieldName === 'percent_discount') {
        this.formData.daily_price[rowIndex]['amount_discount'] = null
      } else if (fieldName === 'amount_discount') {
        this.formData.daily_price[rowIndex]['percent_discount'] = null
      }
      // this.$refs.BookingRoomDailyPriceTable.$refs.agGrid.gridOptions.api.refreshCells(
      //   {
      //     force: true
      //   }
      // )
    },
    async onRoomSelected(room) {
      if (!this.isHydrated) {
        return
      }
      // TODO: Check this with backend for consistent type for ID
      const room_level_id = parseInt(room.room_level_id)
      const isRoomLevelChanged = this.formData.room_type_id !== room_level_id
      this.formData.room_id = room.room_id
      this.hotel_id = room.hotel_id
      this.selectedRoom = room
      this.isSelectRoomDialogOpened = false

      if (isRoomLevelChanged) {
        this.formData.room_type_id = room_level_id
        await this.getDailyPrice()
      }
    },
    onOpenSelectRoomDialog() {
      this.isSelectRoomDialogOpened = true
    },
    onOpenBookingRoomServiceDialog() {
      this.isServiceDialogOpened = true
    },
    onOpenBookingAddChargeDialog() {
      this.isAddChargeDialogOpened = true
    },
    onConfirmService() {
      const payload = this.$refs.BookingRoomServiceDialog.dehydrateTable()
      if (this.action === 'edit-checked-in') {
        payload.forEach((el, index) => {
          if (index < this.formData.sub_booking_group_surcharges.length) {
            return
          }
          el.isAdded = true
        })
      }
      this.formData.sub_booking_group_services = payload
      this.isServiceDialogOpened = false
    },
    onConfirmAddCharge() {
      const payload = this.$refs.BookingRoomAddChargeDialog.dehydrateTable()
      if (this.action === 'edit-checked-in') {
        payload.forEach((el, index) => {
          if (index < this.formData.sub_booking_group_surcharges.length) {
            return
          }
          el.isAdded = true
        })
      }
      this.formData.sub_booking_group_surcharges = payload
      this.isAddChargeDialogOpened = false
    },
    dehydrateForm() {
      const roomType = this.roomLevelOptions.find(
        e => e.room_level_id === this.formData.room_type_id
      )
      const currency_code = this.currencyOptions.find(
        e => e.id === this.formData.currency_id
      ).code

      const payload = JSON.parse(JSON.stringify(this.formData))
      payload.hotel_id = this.hotel_id
      payload.arrive_date = `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`
      payload.depart_date = `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      payload.num_of_night = this.numberOfNights
      payload.room_type_name = roomType?.room_type_name
      payload.room_num = this.selectedRoom?.room_num
      payload.currency_code = currency_code
      if (this.formData.status === 2) {
        payload.sub_booking_group_services =
          payload.sub_booking_group_services.filter(el => el.isAdded)
        payload.sub_booking_group_surcharges =
          payload.sub_booking_group_surcharges.filter(el => el.isAdded)
      }
      return payload
    },
    async hydrateForm(recordData = null) {
      if (recordData == null) {
        return
      }
      Object.assign(this.formData, recordData)
      const arriveTime = this.$moment(this.recordData.arrive_date)
      const departTime = this.$moment(this.recordData.depart_date)
      this.formData.arrive_date = arriveTime.format('YYYY-MM-DD')
      this.formData.depart_date = departTime.format('YYYY-MM-DD')
      this.formData.arrive_time.HH = arriveTime.format('HH')
      this.formData.arrive_time.mm = arriveTime.format('mm')
      this.formData.depart_time.HH = departTime.format('HH')
      this.formData.depart_time.mm = departTime.format('mm')

      this.selectedRoom = {
        room_num: recordData.room_num,
        room_id: recordData.room_id
      }
      this.hotel_id = this.recordData?.hotel_id
    },
    validateForm() {
      if (!this.formData.currency_id) {
        return this.$t('validation.required', { field: 'tiền tệ' })
      }
      if (this.formData.num_of_guest <= 0) {
        return this.$t('validation.required', { field: 'số lượng người lớn' })
      }

      if (this.formData.room_type_id == null) {
        return this.$t('validation.required', { field: 'hạng phòng' })
      }

      for (let i = 0; i < this.formData.daily_price.length; i++) {
        const price = this.formData.daily_price[i]
        if (price.discount_reason && price.discount_reason.length > 50) {
          return this.$t('validation.maxLength', {
            field: 'lý do giảm giá',
            length: 50
          })
        }

        if (price.percent_discount > 100) {
          return this.$t('errorMsg.discountPercentMax100')
        }
      }

      return null
    },
    onRemoveRoom() {
      this.formData.room_id = null
      this.selectedRoom = null
    },
    onChangeHotel() {
      this.formData.is_bf = false
      this.onChangeRoomLevel()
    },
    async onChangeRoomLevel(value = null) {
      console.log('BookingRoomForm group', value)
      if (value != null) {
        this.formData.room_type_id = value.room_level_id
        this.hotel_id = value.hotel_id
        this.formData.sub_booking_group_surcharges = []
        this.formData.num_of_guest = value.people_num
        this.formData.num_of_free_card = value.free_card_quantity
      } else {
        this.formData.room_type_id = null
      }
      await this.getDailyPrice().then(() => this.onRemoveRoom())
    },
    onChangeHourStay(isHourStay) {
      if (!isHourStay) {
        return
      }
      this.formData.depart_date = this.formData.arrive_date
      this.formData.depart_time = {
        HH: '23',
        mm: '00'
      }
    },
    onChangeCurrency(value) {
      // const currency = this.currencyOptions.find(item => item.id === value)
      this.formData.currency_id = value
      // this.formData.exchange_rate = currency.exchange_rate
    },
    async onChangeBookingDate() {
      if (!this.isHydrated) {
        return
      }
      await this.getRoomTypeOptions(
        `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
        `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      )
      await this.getDailyPrice()
      // if (
      //   this.roomLevelOptions.findIndex(
      //     level => level.room_type_id == this.formData.room_type_id
      //   ) === -1
      // ) {
      //   this.formData.daily_price = []
      //   this.formData.room_type_id = null
      //   this.formData.room_id = null
      //   this.selectedRoom = null
      // }
    },
    async getDailyPrice() {
      if (this.formData.room_type_id == null) {
        return
      }
      return generateDailyPriceApi(
        this.formData.arrive_date,
        this.formData.depart_date,
        this.formData.room_type_id,
        this.formData.is_bf
      )
        .then(res => {
          this.formData.daily_price = res.data.map(day => {
            return {
              id: 0,
              price: day.price,
              date: day.date,
              note: null,
              price_code_id: day.price_code_id,
              price_code: day.price_code,
              nett: day.nett,
              currency_id: day.currency_id,
              currency_code: day.currency_code,
              exchange_rate: day.exchange_rate,
              percent_discount: day.percent_discount,
              amount_discount: day.amount_discount,
              discount_reason: day.discount_reason
            }
          })
          this.$message({
            type: 'success',
            message: 'Đã cập nhật chi tiết giá ngày. 1'
          })
        })
        .catch(err => {
          throw err
        })
    },
    async getRoomTypeOptions(arriveDate, departDate) {
      const query = {
        dateFrom: arriveDate,
        dateTo: departDate
      }
      await getBookingGroupAvailableRoomLevelListApi(query)
        .then(res => {
          this.roomLevelOptions = res.data
            .map(type => {
              type.room_type_name = type.room_level_name
              return type
            })
            .sort((level1, level2) => {
              if (level1.hotel_id > level2.hotel_id) {
                return -1
              } else if (level1.hotel_id < level2.hotel_id) {
                return 1
              }
              return 0
            })
        })
        .catch(err => {
          const message = err?.response?.data?.data.message
          this.$message({
            type: 'error',
            message: message
          })
        })
    },
    async getCurrencyOptions() {
      await getAllCurrencyApi().then(response => {
        this.currencyOptions = response.data
        if (this.action === 'create') {
          this.formData.currency_id = this.currencyOptions[0].id
          // this.formData.exchange_rate = this.currencyOptions[0].exchange_rate
        }
      })
    },
    async getHotelOptions() {
      await getAllHotels().then(response => {
        this.hotelOptions = response.data
      })
    },
    async getRoomOptions(roomNumber, hotelId, roomLevelId) {
      const query = {
        roomNumber,
        hotelId,
        roomLevelId
      }
      await getRoomListApi(query).then(response => {
        this.roomOptions = response.data
      })
    }
  }
}
</script>
<style lang="scss">
.ag-theme-balham .ag-row.room-level-row {
  background-color: var(--room-level-background);
  color: var(--room-level-background--hovered);
  font-weight: 500;
  border-color: transparent;
  &:hover {
    background-color: var(--room-level-background--hovered);
    color: white;
  }

  &--green {
    --room-level-background: rgb(22, 101, 52, 0.1);
    --room-level-background--hovered: rgb(22 101 52);
  }
  &--brown {
    --room-level-background: rgb(113, 63, 18, 0.1);
    --room-level-background--hovered: rgb(113 63 18);
  }
  &--purple {
    --room-level-background: rgba(168, 85, 247, 0.1);
    --room-level-background--hovered: rgb(168, 85, 247);
  }
  &--red {
    --room-level-background: rgba(225, 29, 72, 0.1);
    --room-level-background--hovered: rgb(225 29 72);
  }
  &--yellow {
    --room-level-background: rgba(234, 179, 8, 0.2);
    --room-level-background--hovered: rgb(234 179 8);
  }
}
</style>
